(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('action-ap-mutate-component-data', actionFunc);

    function actionFunc($q, lodash, $injector, PanelManager) {
        return function(panel, options, eventData, actionData) {
            const panelStateObj = {
                options,
                eventData,
                actionData
            };
            $q.when(options.map(function(option) {
                const library = $injector.get(option.component);
                if (lodash.has(option, 'panel_id')) {
                    lodash.set(panelStateObj, 'panel', PanelManager.get(option.panel_id));
                } else {
                    lodash.set(panelStateObj, 'panel', panel);
                }
                // if have data, will take precendent and directly set the state using its content
                if (lodash.has(option, 'data')) {
                    if (lodash.has(option, 'replacements')) {
                        /**
                         * {
                         *      source: <- the path to the value of interest
                         *      target: <- the path to the value we want to replace
                         *      key: <- the regex key we want to replace at the source. Optional
                         *              if Key does not exist, the source value will be replaced entirely by the target value.
                         * }
                         */
                        for (const replacement of option.replacements) {
                            let replacementValue = lodash.get(panelStateObj, replacement.source, '');

                            if (lodash.has(replacement, 'key')) {
                                const replacementTarget = lodash.get(option.data, replacement.target,'');
                                replacementValue = decodeURI(replacementTarget.replace(new RegExp(replacement.key, 'g'), replacementValue));
                            }
                            lodash.set(
                                option.data,
                                replacement.target,
                                replacementValue
                            );
                        }
                    }

                    // panel.setState(option.key, option.data);

                    library.setData(option.key, option.data);
                }
                // if no data, then look for next best thing, model key
                if (!lodash.has(option, 'data') && lodash.has(option, 'modelKey')) {
                    // panel.setState(key, lodash.get(model, option.modelKey, null));
                    library.setData(option.key, lodash.get(panelStateObj, option.modelKey, null));
                }
                return true;
            }));

            // return $q.when(run());
            // function run() {
            //
            //
            //
            //     return ListFilterService.getData(options.path);
            // }
        };
    }
})();
